module.exports = __webpack_public_path__ + "img/07.bb95a436.png";